<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg">
      <HeaderMenu />
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <!-- Notificaciones -->
        <div class="position-fixed top-0 end-0 p-3" style="z-index: 1050;">
          <div v-for="(notification, index) in notifications" :key="index"
            :class="['alert', notification.class, 'alert-dismissible fade show']" role="alert">
            {{ notification.message }}
            <button type="button" class="btn-close" @click="closeNotification(index)"></button>
          </div>
        </div>

        <!-- Verificación de permisos de administrador -->
        <div v-if="!esAdministrador && !cargandoUsuario" class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body text-center py-5">
                <i class="fas fa-lock fa-3x text-danger mb-3"></i>
                <h4>Acceso Restringido</h4>
                <p class="text-muted">Solo los administradores pueden acceder a esta sección.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel de Control de Tareas -->
        <div v-else class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="card-header d-flex align-items-center">
                <h6 class="mb-0">
                  <i class="fas fa-tasks me-2"></i>
                  Panel de Control de Tareas
                </h6>
                <button class="btn btn-primary btn-sm ms-auto" @click="cargarTareas" :disabled="cargando">
                  <span v-if="cargando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  Recargar
                </button>
              </div>
              <div class="card-body">
                <!-- Filtros -->
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="form-label small">Filtrar por tipo:</label>
                    <select class="form-select form-select-sm" v-model="filtroTipo" @change="aplicarFiltros">
                      <option value="">Todos los tipos</option>
                      <option value="aprobacion">Aprobación</option>
                      <option value="caducidad">Caducidad</option>
                      <option value="firma_pantalla">Firma en pantalla</option>
                      <option value="firma_vidsigner">Firma VidSigner</option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label small">Filtrar por esquema:</label>
                    <select class="form-select form-select-sm" v-model="filtroEsquema" @change="aplicarFiltros">
                      <option value="">Todos los esquemas</option>
                      <option v-for="esquema in esquemasUnicos" :key="esquema.id" :value="esquema.id">
                        {{ esquema.nombre }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="cargando" class="text-center my-4">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="text-muted mt-2">Cargando tareas...</p>
                </div>
                <div v-else>
                  <div v-if="tareasFiltradas.length === 0" class="mensaje-sin-tareas">
                    <i class="fas fa-info-circle me-2"></i>
                    No hay tareas pendientes con los filtros aplicados.
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th style="min-width: 120px;">Tipo</th>
                          <th style="min-width: 150px;">Esquema</th>
                          <th style="min-width: 200px;">Documento</th>
                          <th style="min-width: 150px;">Usuarios asignados</th>
                          <th style="min-width: 100px;">Total tareas</th>
                          <th style="min-width: 150px;">Fecha creación</th>
                          <th style="min-width: 150px;">Creado por</th>
                          <th style="min-width: 120px;">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="tarea in tareasFiltradas" :key="`${tarea.esquema_id}_${tarea.registro_id}_${tarea.tipo}`">
                          <td>
                            <span class="badge" :class="getBadgeClass(tarea.tipo)">
                              {{ getTipoLabel(tarea.tipo) }}
                            </span>
                          </td>
                          <td class="text-sm">
                            <span class="badge" :style="{ backgroundColor: getEsquemaColor(tarea.esquema_id) }">
                              {{ tarea.esquema_nombre }}
                            </span>
                          </td>
                          <td class="text-sm">{{ tarea.nombre_documento || '-' }}</td>
                          <td>
                            <div class="d-flex flex-wrap gap-1">
                              <span v-for="(usuario, index) in tarea.usuarios_asignados" :key="index"
                                class="badge bg-secondary small">
                                {{ usuario }}
                              </span>
                              <span v-if="tarea.usuarios_asignados.length === 0" class="text-muted small">-</span>
                            </div>
                          </td>
                          <td class="text-center">
                            <span class="badge bg-info">{{ tarea.total_tareas }}</span>
                          </td>
                          <td class="text-sm">{{ formatDateTime(tarea.fecha_creacion) || '-' }}</td>
                          <td class="text-sm">
                            {{ tarea.datos_tarea?.creado_por || '-' }}
                          </td>
                          <td>
                            <button class="btn btn-primary btn-sm" @click="verDocumento(tarea)">
                              <i class="fas fa-eye me-1"></i>
                              Ver
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  <!-- Resumen -->
                  <div v-if="tareasFiltradas.length > 0" class="mt-3 pt-3 border-top">
                    <div class="row text-center">
                      <div class="col-md-3">
                        <div class="small text-muted">Total de grupos</div>
                        <div class="h5 mb-0">{{ tareasFiltradas.length }}</div>
                      </div>
                      <div class="col-md-3">
                        <div class="small text-muted">Total de tareas</div>
                        <div class="h5 mb-0">{{ totalTareas }}</div>
                      </div>
                      <div class="col-md-3">
                        <div class="small text-muted">Aprobaciones</div>
                        <div class="h5 mb-0">{{ tareasPorTipo.aprobacion }}</div>
                      </div>
                      <div class="col-md-3">
                        <div class="small text-muted">Caducidades</div>
                        <div class="h5 mb-0">{{ tareasPorTipo.caducidad }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import { onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import axiosInstance from "@/axios";
import { useAuth } from "@/composables/useAuth";

export default {
  name: "PanelControlTareasView",
  components: { HeaderMenu },
  setup() {
    const router = useRouter();
    const { user, getCurrentUser } = useAuth();
    const notifications = ref([]);
    const tareas = ref([]);
    const cargando = ref(false);
    const cargandoUsuario = ref(true);
    const esAdministrador = ref(false);
    const filtroTipo = ref('');
    const filtroEsquema = ref('');

    // Función para cerrar una notificación
    const closeNotification = (index) => {
      notifications.value.splice(index, 1);
    };

    const showNotification = (message, type) => {
      const notification = {
        message,
        class: type,
      };
      notifications.value.push(notification);
      setTimeout(() => {
        closeNotification(notifications.value.indexOf(notification));
      }, 3000);
    };

    // Verificar si el usuario es administrador
    const verificarAdministrador = async () => {
      cargandoUsuario.value = true;
      try {
        // Primero intentar obtener is_admin desde check-token (que sabemos que lo devuelve)
        let isAdminValue = null;
        try {
          const checkTokenResponse = await axiosInstance.get('/api/check-token');
          // is_admin está dentro de user
          if (checkTokenResponse.data && checkTokenResponse.data.user && checkTokenResponse.data.user.is_admin !== undefined) {
            isAdminValue = checkTokenResponse.data.user.is_admin;
          }
        } catch (e) {
          console.error("Error al obtener is_admin desde check-token", e);
        }
        
        // Si no lo obtuvimos de check-token, intentar desde el usuario del store/localStorage
        if (isAdminValue === null) {
          let usuario = user.value;
          
          // Si no está en el store, intentar desde localStorage
          if (!usuario) {
            const userData = localStorage.getItem('user_data');
            if (userData) {
              try {
                usuario = JSON.parse(userData);
              } catch (e) {
                console.error("Error al parsear user_data de localStorage", e);
              }
            }
          }
          
          // Si aún no tenemos usuario, obtenerlo del endpoint
          if (!usuario) {
            usuario = await getCurrentUser();
          }
          
          if (usuario && usuario.is_admin !== undefined) {
            isAdminValue = usuario.is_admin;
          }
        }
        
        // Verificar de múltiples formas posibles
        if (isAdminValue !== null && isAdminValue !== undefined) {
          const isAdmin = isAdminValue === 1 || 
                        isAdminValue === true || 
                        isAdminValue === '1' ||
                        String(isAdminValue) === '1' ||
                        isAdminValue === 'true';
          esAdministrador.value = isAdmin;
        } else {
          esAdministrador.value = false;
        }
      } catch (error) {
        console.error("Error al verificar usuario", error);
        esAdministrador.value = false;
      } finally {
        cargandoUsuario.value = false;
      }
    };

    // Cargar tareas del panel de control
    const cargarTareas = async () => {
      if (!esAdministrador.value) return;
      
      cargando.value = true;
      try {
        const response = await axiosInstance.get("/api/panelControlTareas");
        if (response.data.success) {
          tareas.value = response.data.tareas || [];
        } else {
          showNotification("Error al cargar las tareas", 'alert-danger');
          tareas.value = [];
        }
      } catch (error) {
        console.error("Error al cargar tareas", error);
        showNotification("Error al cargar las tareas", 'alert-danger');
        tareas.value = [];
      } finally {
        cargando.value = false;
      }
    };

    // Esquemas únicos para el filtro
    const esquemasUnicos = computed(() => {
      const esquemasMap = new Map();
      tareas.value.forEach(tarea => {
        if (tarea.esquema_id && !esquemasMap.has(tarea.esquema_id)) {
          esquemasMap.set(tarea.esquema_id, {
            id: tarea.esquema_id,
            nombre: tarea.esquema_nombre
          });
        }
      });
      return Array.from(esquemasMap.values());
    });

    // Tareas filtradas
    const tareasFiltradas = computed(() => {
      let filtradas = tareas.value;
      
      if (filtroTipo.value) {
        filtradas = filtradas.filter(t => t.tipo === filtroTipo.value);
      }
      
      if (filtroEsquema.value) {
        filtradas = filtradas.filter(t => t.esquema_id === parseInt(filtroEsquema.value));
      }
      
      return filtradas;
    });

    // Total de tareas individuales
    const totalTareas = computed(() => {
      return tareasFiltradas.value.reduce((sum, t) => sum + (t.total_tareas || 0), 0);
    });

    // Tareas por tipo
    const tareasPorTipo = computed(() => {
      const tipos = {
        aprobacion: 0,
        caducidad: 0,
        firma_pantalla: 0,
        firma_vidsigner: 0
      };
      
      tareasFiltradas.value.forEach(t => {
        if (Object.prototype.hasOwnProperty.call(tipos, t.tipo)) {
          tipos[t.tipo]++;
        }
      });
      
      return tipos;
    });

    // Aplicar filtros
    const aplicarFiltros = () => {
      // Los filtros se aplican automáticamente mediante computed
    };

    // Obtener clase del badge según el tipo
    const getBadgeClass = (tipo) => {
      const clases = {
        aprobacion: 'bg-warning',
        caducidad: 'bg-danger',
        firma_pantalla: 'bg-success',
        firma_vidsigner: 'bg-info'
      };
      return clases[tipo] || 'bg-secondary';
    };

    // Obtener etiqueta del tipo
    const getTipoLabel = (tipo) => {
      const etiquetas = {
        aprobacion: 'Aprobación',
        caducidad: 'Caducidad',
        firma_pantalla: 'Firma Pantalla',
        firma_vidsigner: 'Firma VidSigner'
      };
      return etiquetas[tipo] || tipo;
    };

    // Obtener color del esquema (por defecto gris)
    const getEsquemaColor = (esquemaId) => {
      // Por ahora retornamos un color por defecto
      // En el futuro se podría cargar los esquemas para obtener sus colores
      // usando el parámetro esquemaId
      if (esquemaId) {
        // Parámetro reservado para uso futuro cuando se carguen los esquemas
      }
      return '#6c757d';
    };

    // Formatear fecha y hora
    const formatDateTime = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    // Ver documento
    const verDocumento = (tarea) => {
      router.push({
        path: `/esquema/${tarea.esquema_id}/registro/${tarea.registro_id}`
      });
    };

    onMounted(async () => {
      await verificarAdministrador();
      if (esAdministrador.value) {
        await cargarTareas();
      }
    });

    return {
      notifications,
      closeNotification,
      showNotification,
      tareas,
      cargando,
      cargandoUsuario,
      esAdministrador,
      filtroTipo,
      filtroEsquema,
      esquemasUnicos,
      tareasFiltradas,
      totalTareas,
      tareasPorTipo,
      aplicarFiltros,
      getBadgeClass,
      getTipoLabel,
      getEsquemaColor,
      formatDateTime,
      verDocumento,
      cargarTareas
    };
  },
}
</script>

<style scoped>
.table th {
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #6c757d;
}

.table td {
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
}

.small {
  font-size: 0.75rem;
}

.mensaje-sin-tareas {
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  border: 1px solid #0dcaf0;
  color: #055160;
  background-color: #f0f9ff;
}
</style>

